var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('tooltip', {
    attrs: {
      "text": _vm.value.description,
      "disabled": !_vm.value.description,
      "placement": "top"
    }
  }, [_c('v-chip', {
    attrs: {
      "color": _vm.value.color,
      "x-small": 'x-small' === _vm.size,
      "small": 'small' === _vm.size,
      "large": 'large' === _vm.size,
      "x-large": 'x-large' === _vm.size,
      "dark": ""
    }
  }, [_vm.value.icon ? _c('v-icon', {
    attrs: {
      "x-small": 'x-small' === _vm.size,
      "small": 'small' === _vm.size,
      "large": 'x-large' === _vm.size,
      "left": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.value.icon) + " ")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.value.value) + " ")], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }